<router>
{
    name: 'Customers',
}
</router>
<template lang="pug">
v-container
    DevopsUsers

</template>
<script>

import DevopsUsers from '@/components/devops/users';
export default {
    meta: {
        role: 'devopsupdate'
    },
    components: {
        DevopsUsers,
    },
    data () {
        return {
        };
    },
    methods: {

    },
    computed: {

    },
    mounted () {
    }
};
</script>

<style scoped>
</style>
